import { GetIssueResponseDto, useApi } from '@issuemanager/api-client';
import { type ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { ApproveIssueRequestDto } from '@issuemanager/routes';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useApproveIssue(code: string, onSuccess: () => void) {
  const api = useApi();

  const queryClient = useQueryClient();

  return useMutation<
    GetIssueResponseDto,
    ExtendedAxiosError,
    ApproveIssueRequestDto
  >({
    mutationKey: ['issues', code],
    mutationFn: (r) => api.issuesApi.approveIssue(code, r).then((r) => r.data),
    onSuccess: async (response) => {
      queryClient.setQueryData<GetIssueResponseDto>(['issues', code], response);
      onSuccess();
    },
  });
}
